import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { useToast } from "@/hooks/use-toast";
import { updateAdminListingResourceIdAction } from "../actions/listings.actions";
export const useAdminUpdateListingResourceId = () => {
  const $ = _c(3);
  const {
    toast
  } = useToast();
  const t = useTranslations("modules.portfolio.associateListingToUnit.toast");
  let t0;
  if ($[0] !== t || $[1] !== toast) {
    t0 = {
      mutationFn: _temp,
      onSuccess: (_, variables) => {
        toast({
          title: t("successTitle"),
          description: variables.unitName ? t("associatedDescription", {
            unitName: variables.unitName
          }) : t("dissociatedDescription")
        });
      },
      onError: () => {
        toast({
          title: t("errorTitle"),
          variant: "destructive"
        });
      }
    };
    $[0] = t;
    $[1] = toast;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useMutation(t0);
};
function _temp(t0) {
  const {
    listingId,
    resourceId
  } = t0;
  return updateAdminListingResourceIdAction({
    listingId,
    resourceId
  });
}